import { CookieService } from "ngx-cookie-service";
import { DOCUMENT, isPlatformBrowser } from "@angular/common";
import { Injectable, PLATFORM_ID, inject } from "@angular/core";
import { ACCESS_TOKEN_KEY, ACCESS_TOKEN_KEY_CLIENT, CATEGORY_DATA, CLIENT_DATA, EXPIRE_IN_KEY, EXPIRE_IN_KEY_CLIENT, REFRESH_TOKEN_KEY, THEME, TRANSFORM_PROFILE_DATA } from "constants/storage-keys";
import { JwtHelperService } from "@auth0/angular-jwt";
import { CLIENT_COOKIES } from "@environments/enviromenter/environmenter-token";

@Injectable({
    providedIn: `root`,
})
export class LocalRepository {
    private platformId = inject(PLATFORM_ID);
    private cookies = inject(CLIENT_COOKIES, { optional: true });
    private cookieService = inject(CookieService);
    private jwtHelper = inject(JwtHelperService);
    private doc = inject<Document>(DOCUMENT);

    private isInBrowser: boolean;

    private static _Instance: LocalRepository;

    private serverParsedCookies: Record<string, unknown> = {};

    public static get Instance(): LocalRepository {
        return LocalRepository._Instance;
    }

    constructor() {

        this.isInBrowser = isPlatformBrowser(this.platformId);
        LocalRepository._Instance = this;
        if (!this.isInBrowser) {
            this.serverParsedCookies = this.cookies || {};
        }
    }

    public get IsInMobile(): boolean {
        const userAgent = this.getWindow?.navigator?.userAgent! || this.getWindow?.navigator?.vendor!;
        const mobile = /android/i.test(userAgent) || /iPhone|ipad|iPod/i.test(userAgent);
        return mobile;
    }

    public get IsInBrowser(): boolean {
        return this.isInBrowser;
    }

    public get getWindow(): Window | null {
        return this.doc.defaultView;
    }

    public get getDocument(): Document {
        if (this.isInBrowser) {
            return document;
        }
        else
            return this.doc;
    }

    public getLocalItem(key: string): string | null {
        if (this.IsInBrowser) {
            return localStorage.getItem(key);
        }
        else return null;
    }

    public setLocalItem(key: string, value: string) {
        if (this.isInBrowser) {
            localStorage.setItem(key, value);
        }
    }

    public getCookieItem(key: string): string | null {
        const value = this.isInBrowser ? (this.cookieService?.get(key) || null) : (this.serverParsedCookies[key] as string || null)
        return value;
    }

    public setCookieItem(key: string, value: string) {
        if (this.isInBrowser) {
            this.cookieService.set(key, value, { path: '/', expires: 60});
        }
        else {
            this.serverParsedCookies[key] = value;
        }
    }

    public removeLocalItem(key: string) {
        if (this.isInBrowser) {
            localStorage.removeItem(key);
        }
    }


    public removeCookieItem(key: string) {
        if (this.isInBrowser)
            this.cookieService.delete(key);
        else
            delete this.serverParsedCookies[key];
    }


    public resetCredentials(access_token: string, refresh_token: string, expire: string): void {
        this.setCookieItem(ACCESS_TOKEN_KEY, access_token!);
        this.setCookieItem(EXPIRE_IN_KEY, expire!);
        this.setCookieItem(REFRESH_TOKEN_KEY, refresh_token!);
        this.removeCookieItem(EXPIRE_IN_KEY_CLIENT);
    }

    public getDecodedToken(): any {
        const token = this.getCookieItem(ACCESS_TOKEN_KEY);
        try {
            return this.jwtHelper.decodeToken(token!);
        } catch  {
            return undefined;
        }
    }

    public clearUserData() {
        const accessTokenClient = this.cookieService.get(ACCESS_TOKEN_KEY_CLIENT);
        this.cookieService.deleteAll('/');
        this.cookieService.set(ACCESS_TOKEN_KEY_CLIENT, accessTokenClient);
        this.cookieService.set(THEME, 'light');
        this.removeLocalItem(CLIENT_DATA);
        this.removeLocalItem(TRANSFORM_PROFILE_DATA);
        this.removeLocalItem(CATEGORY_DATA);
        this.removeLocalItem('UserInviteCode');
        this.removeLocalItem('filters');
        this.removeLocalItem("userId");
        this.removeLocalItem("displaySetAvatar");
        this.removeLocalItem('draft');
    }

}
